import { mutationFactory } from 'vuex-factories'
import actions from './actions'

export default {
  namespaced: true,
  state: {
    candidateEntry: {},
  },
  getters: {},
  actions,
  mutations: {
    ...mutationFactory({
      SET_CANDIDATE_ENTRY_DATA: [{ key: 'candidateEntry' }],
    }),
  },
}
